import { render, staticRenderFns } from "./VariantSelect.vue?vue&type=template&id=08b4f8fa&"
import script from "./VariantSelect.vue?vue&type=script&lang=js&"
export * from "./VariantSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports